import { LoadableAfterPaint } from '@confluence/loadable';

export const UpgradeFreePoolExperimentModalPreUpgradeModalLoadable = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-UpgradeFreePoolExperimentModalPreUpgrade" */ './base-component.tsx'
			)
		).UpgradeFreePoolExperimentModalPreUpgradeModalBaseComponent,
});
